<script setup>
import HeadlineComponent from "./Headline.vue";
import {onActivated, ref, computed, watch, inject} from "vue";
import PageTransition from "./PageTransition.vue";
import GuidanceComponent from "../../layouts/components/Notice.vue";

const props = defineProps({
    previousIndex: Number,
    title: String,
    message: String,
    selections: Array,
    image: {
        type: String,
        required: false,
        default: null
    },
    inputValues: Object,
    isTopReturn: {
        type: Boolean,
        required: false,
        default: false
    },
    isRecordAnswer: {
        type: Boolean,
        required: false,
        default: true
    },
    nextIndex: Number,
});


const index = inject('index');
watch(index , (newId, oldId) => {
    selectedSelection.value = getSelectedSelection();
    selectedText.value = selectedSelection.value ? selectedSelection.value.text : null;
});
function getSelectedSelection () {
    if (!props.title in props.inputValues) {
        return null;
    }
    const selection = props.selections.find(object => object.text === props.inputValues[props.title]);
    if (!selection) {
        return null
    }
    return selection;
}
const selectedSelection = ref(null);
function selectIndex(selection) {
    selectedSelection.value = selection;
}
const selectedText = ref(() => {
   return selectedSelection.value ? selectedSelection.value.text : null;
});

const isActiveButton = computed(() => {
    if (props.selections.length === 0) return true;
    return selectedSelection.value !== null;
});

onActivated(() => {
    // アクティブになった際に入力情報を持っていたら初期値を設定する
    selectedSelection.value = getSelectedSelection();
});

const emit = defineEmits(['changeIndex', 'resetInputValue']);
function changeIndex(index, key, value) {
    if (!props.isRecordAnswer) return;
    emit('changeIndex', index, key, value);
}


</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component :title="props.title"/>
            <div class="uk-margin uk-flex-center uk-flex-1" style="overflow-y: auto;">
                <Guidance-component v-if="message" class="uk-width-1-1" :message="message"/>
                <div class="uk-flex uk-flex-column">
                    <template v-for="selection in selections">
                        <div class="uk-flex uk-width-medium uk-margin-auto uk-text-left">
                            <label class="uk-margin-bottom uk-width-1 uk-text-center" :class="{'checked' : selectedText === selection.text}">
                                <input type="radio" class="uk-radio uk-margin-remove-left"
                                       style="display: none;"
                                       :value="selection.text"
                                       v-model="selectedText"
                                       @click="selectIndex(selection)"/>
                                <span style="white-space: pre-wrap;">
                                    {{ selection.text }}
                                </span>
                            </label>
                        </div>
                    </template>
                    <img v-if="image" :src="image" alt=""/>
                </div>
            </div>
            <page-transition
                @change-index="(index,key,value) => { changeIndex(index,key,value); }"
                @reset-input-value="(index) => {$emit('resetInputValue', index);}"
                :index="index"
                :previous-index="previousIndex"
                :next-index="selectedSelection ? selectedSelection.index : nextIndex"
                :input-key="title"
                :value="selectedSelection ? selectedSelection.text : null"
                :is-active-button="isActiveButton"
                :selections="null"
                :is-top-return="isTopReturn"
            ></page-transition>
        </div>
    </div>
</template>

<style scoped>
label {
    font-size: 1.1rem;
    padding: 5px 20px;
    background-color: #fff;
    border: 2px solid #257cde;
    border-radius: 50px;
    > input {
        margin-left: 25%;
        opacity: 0;
    }
    &:hover {
        cursor: pointer;
        border: 3px solid #257cde;
        padding: 4px 20px;
    }
    &.checked {
        background-color: #257cde;
        color: #fff;
        > input {
            margin-left: 25%;
        }
    }
}

</style>